// NOTE: This duplicates backend curve math (EventStage) for live preview only.
// Actual rate computation happens server-side. If the formula changes, update both locations.

export function computeMultiplier(peakMult: number, progress: number, curve: string): number {
  const delta = peakMult - 1
  const adjustedProgress = curve === 'ease_in' ? progress * progress : progress
  return 1 + delta * adjustedProgress
}

export function addDays(dateStr: string, days: number): Date {
  const d = new Date(dateStr + 'T00:00:00')
  d.setDate(d.getDate() + days)
  return d
}

export function addDaysToDate(d: Date, days: number): Date {
  const result = new Date(d)
  result.setDate(result.getDate() + days)
  return result
}

export function formatShortDate(d: Date): string {
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
}

/**
 * Format a Date as a `YYYY-MM-DD` key using LOCAL date components — NOT
 * `toISOString()`, which formats in UTC and names the wrong calendar day for
 * local-midnight dates when the user is east of UTC. Keys produced here must
 * stay aligned with `todayIso()` (also local) so the "Today" reference line
 * matches chart data points in every timezone.
 */
export function dateToKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}
